<div class="page-ib">
  <div class="row">
    <div class="col">
      <fx-page-header
        title="Trader"
      ></fx-page-header>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <fx-trader-list></fx-trader-list>
    </div>
  </div>
</div>
